import {
    Badge,
    Button,
    Card,
    Divider,
    Drawer,
    Form,
    Icon,
    Input,
    Modal,
    Radio,
    Result,
    Spin,
    Statistic,
    Tabs,
    Tag,
    Tooltip,
    Typography,
    message,
    notification
} from 'antd';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import {
    DeleteOutlined,
    DesktopOutlined,
    EditOutlined,
    EyeInvisibleOutlined,
    EyeOutlined,
    RedoOutlined,
    SaveOutlined,
    SettingOutlined,
    TwitterOutlined,
    UndoOutlined,
    ZoomInOutlined,
    ZoomOutOutlined
} from '@ant-design/icons';
import { DiffOutlined, PlusOutlined } from '@ant-design/icons';

import { HotKeys } from "react-hotkeys";
import { Layer } from '../utils/l2'
import { Layout } from 'antd';
/**
 * This is where all the paper-games are going to be. Biatch
 */
import React from 'react';
import ReactJson from 'react-json-view'
import { Rig } from './3d/rig'
import { UploadData } from '../api/setters'
import WebWorker from './workers/workerSetup';
import drawWorker from './workers/drawWorker.js';
import { useMediaQuery } from 'react-responsive'

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 })
  return isDesktop ? children : null
}
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  return isTablet ? children : null
}
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}
const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}


const { Meta } = Card;
const { TabPane } = Tabs;
const { Header, Footer, Sider, Content } = Layout;
const { info } = Modal;

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 24 },
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 },
};


export class Poser extends React.Component {
    /**
     * This is the main canvas where a peeps gonna draw
     * @param {T} props 
     */
    constructor(props) {
        super(props);

        var browserZoomRatio = window.devicePixelRatio;
        var prettyPadding = 20;
        var siderWidth = 300; //make sure you change this in the state as well
        // If height and width are not set then just use the screen height and width
        var canvHeight = !!this.props.height ? this.props.height : window.innerHeight - prettyPadding
        var canvWidth = !!this.props.width ? this.props.width : window.innerWidth - siderWidth - prettyPadding
        var offsetW = !!this.props.width ? ((window.innerWidth + siderWidth) * browserZoomRatio - this.props.width) / 2 : window.innerWidth/ 2 + siderWidth + prettyPadding/2
        var offsetH = !!this.props.height ? (window.innerHeight * browserZoomRatio - this.props.height) / 2 : window.innerHeight/ 2 + prettyPadding/2

        // const base_canvas  = new OffscreenCanvas(100, 1);
        // const ctx = canvas.getContext('2d');

        var baseLayer = {
            "index": 0,
            "component": <Layer
                name="Base Layer"
                visibility='visible'
                height={canvHeight}
                width={canvWidth}
                isBase={true} // only base layer will have a background. Rest will be transparent
            />,
            "visible": true,
            "name": "Base Layer"
        }


        this.state = {
            appLoading: true,
            canvHeight: canvHeight,
            canvWidth: canvWidth,
            offsetW: offsetW,
            offsetH: offsetH,
            baseLayer: baseLayer,
            layerList: [],

            activeLayer: baseLayer,

            // props for layer drawer
            layerDrawerVisisble: false,
            currentLayerCount: 0,
            layerVisibilityMap: [true, true, true, true, true, true, true, true, true, true], // all visible by defualt
            activeList: [false, false, false, false, false, false, false, false, false, false], //Active tab lookup (i know this is primitive but fuck you)

            // canvas drawing props
            flag: false,
            prevX: 0,
            currX: 0,
            prevY: 0,
            currY: 0,
            dot_flag: false,

            x: "black",
            y: 2,

            // brush props
            brushSize: 1,

            // Canvas Scale (for zoom in and zoom out)
            zoom_scale: 1,

            // Painting states
            painting: false,
            activeCanvasContext: null,
            offScreenContexts: {}, // Maintain all the offscreen contexts on this dict. Pass only one control at a time

            // History Stack
            // This stack will ultimately be drawing data will be used to generate
            // datasets
            strokeHistory: [],
            strokeUndoReplay: [], // temp buffer to store strokes in case undo pressed
            lastStrokeMemento: [],
            canvasHistDict: { "Base Layer": 0 }, //will store layer edit count. If layer edits are 0 then will clear layer
            canvasHistory: [], // push into this on component mounting
            maxUndoLimit: 40, // Allow only a max of 40 undos for this MVP
            historyPointer: -1, // This will point to the canvas state on Undo/Redo

            // Workers for each fucking layer nibba
            workerLookup: {},

            // Save Modal settings
            save_modal_visible: false,
            save_modal_loading: false,
            artTitle: "",
            titlePresent: false,

            // 3d states
            Drawer3DVisisble: false,

            hideHeader: false,

            //sider props
            siderWidth: 300,

            sample_stroke_format: {
                "description": "A memento is a list of points that make a stroke. Memento can be interpreted as [x_cor, y_cor, x_offset, y_offset]. Offsets are used for display purpose. An empty ([]) memento element signifies end of stroke.",
                "stroke": [{
                    "layer": "Base Layer",
                    "type": "event type can be mouseup or penup",
                    "memento": [
                        [
                        ]
                    ]
                }, {
                    "layer": "Base Layer",
                    "type": "mouseup",
                    "memento": [
                        [553, 176, -310, -10],
                        [545, 205, -310, -10],
                        [555, 294, -310, -10],
                        [593, 372, -310, -10],
                        [621, 400, -310, -10],
                        [628, 402, -310, -10],
                        [631, 382, -310, -10],
                        []
                    ]
                }],
                "device_type": "pc",
                "canvas_h": 600,
                "canvas_w": 626
            }


        }

        this.showFullScreenConfirm = this.showFullScreenConfirm.bind(this)


    }




    getTouchPos = (e) => {
        if (!e)
            return false
        if (e.touches) {
            if (e.touches.length == 1) { // Only deal with one finger
                var touch = e.touches[0]; // Get the information for finger #1
                return [touch.clientX, touch.clientY]
            }
        }
    }

    getMousePos = (e) => {
        /**
         * Wow what a beautiful function. Wow. This is amazing.
         * I have created a master piece
         */
        e.persist()
        var doc = document.documentElement;
        var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        var scrollOffX = (document.body.scrollWidth - window.innerWidth) / 2
        var scrollOffY = (document.body.scrollHeight - window.innerHeight) / 2
        var browserZoomRatio = window.devicePixelRatio;
        var Xoffset = (window.innerWidth * (1 - browserZoomRatio)) / 2
        var Yoffset = (window.innerHeight * (1 - browserZoomRatio)) / 2
        var newPos = {
            "clientX": e.clientX - Xoffset - (scrollOffX - left),
            "clientY": e.clientY - Yoffset - (scrollOffY - top)
        }
        return newPos
    }



    // Add painting listeners
    startTouchPosition = (e) => {
        e.persist()
        var touch = this.getTouchPos(e)
        if (!!!touch) {
            return
        }

        var off_screen_context = this.getOffScreenContext()

        // load the web-worker for active layer
        var webW = this.state.workerLookup[this.state.activeLayer.name]
        var drawWorkerEle = webW.worker

        var workerDrawMessage = {
            "message_type": "start",
            "layer_name": this.state.activeLayer.name,
            "x": touch[0] - this.state.offsetW,
            "y": touch[1] - this.state.offsetH,
            "lw": this.state.brushSize,
            "lcap": "round",
            "canvas": off_screen_context
        }

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        webW.revoke() // cleanup

        this.setState({
            painting: true,
            activeCanvasContext: null
        })
    }

    // Add painting listeners
    startPosition = (e) => {
        e.persist()

        var off_screen_context = this.getOffScreenContext()

        var p2 = this.getMousePos(e)

        // load the web-worker for active layer
        var webW = this.state.workerLookup[this.state.activeLayer.name]
        var drawWorkerEle = webW.worker

        var workerDrawMessage = {
            "message_type": "start",
            "layer_name": this.state.activeLayer.name,
            "x": p2.clientX - this.state.offsetW,
            "y": p2.clientY - this.state.offsetH,
            "lw": this.state.brushSize,
            "lcap": "round",
            "canvas": off_screen_context
        }

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        webW.revoke() // cleanup

        this.setState({
            painting: true,
            activeCanvasContext: null
        })
    }

    finishPosition = (e) => {

        this.setState({
            painting: false
        })
        // Here you do two most important things:
        // 1. Reset the stroke and append to memento and append to stroke history
        // 2. Append the current state of the active layer to the canvas history

        var lastStrokeMemento = this.state.lastStrokeMemento
        lastStrokeMemento.push([]) // [] denotes end of stroke
        var strokeHistory = this.state.strokeHistory
        strokeHistory.push(
            {
                "layer": this.state.activeLayer.name,
                "type": e.type,
                "memento": lastStrokeMemento
            })

        this.setState({
            strokeHistory: strokeHistory,
            lastStrokeMemento: [],// reset the last stroke memento
            strokeUndoReplay: []

        })

        // make it such that all the commits or stuff like saving shit to canvas happen in the worker 
        // commit the current canvas state to history
        this.commitCanvasData(this.state.activeLayer.name) // this will push the current layer to hist as well
    }


    // Set mouse events to the canva

    getOffScreenContext = () => {
        // internally will pick up the off-screen context
        var off_screen_context = null
        if (this.state.activeLayer.name in this.state.offScreenContexts) {
            off_screen_context = this.state.offScreenContexts[this.state.activeLayer.name]
        }
        else {
            var canv_ctx = document.getElementById(this.state.activeLayer.name).transferControlToOffscreen();
            // console.log(canv_ctx)
            var offScreenContexts = this.state.offScreenContexts
            offScreenContexts[this.state.activeLayer.name] = canv_ctx
            off_screen_context = canv_ctx
            this.setState({
                offScreenContexts: offScreenContexts
            })
        }

        return off_screen_context
    }

    getUndoRedoContext = (layer_name) => {
        // internally will pick up the off-screen context
        var off_screen_context = null
        if (layer_name in this.state.offScreenContexts) {
            off_screen_context = this.state.offScreenContexts[layer_name]
        }
        else {
            var canv_ctx = document.getElementById(layer_name).transferControlToOffscreen();
            // console.log(canv_ctx)
            var offScreenContexts = this.state.offScreenContexts
            offScreenContexts[layer_name] = canv_ctx
            off_screen_context = canv_ctx
            this.setState({
                offScreenContexts: offScreenContexts
            })
        }

        return off_screen_context
    }

    // Darw with mouse
    drawMouse = (e) => {

        e.persist();
        // Workerized  drawMouse function
        if (this.state.painting) {

            var p2 = this.getMousePos(e)
            // Get offscreen worker
            var off_screen_context = this.getOffScreenContext()
            var workerDrawMessage = {
                "message_type": "draw",
                "layer_name": this.state.activeLayer.name,
                "x": p2.clientX - this.state.offsetW,
                "y": p2.clientY - this.state.offsetH,
                "lw": this.state.brushSize,
                "lcap": "round",
                "canvas": off_screen_context
            }

            // load the web-worker for active layer
            var webW = this.state.workerLookup[this.state.activeLayer.name]
            var drawWorkerEle = webW.worker

            try {
                // You must pass context only once. The next time you send, you should just send the message
                drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
            } catch (error) {
                workerDrawMessage['canvas'] = false
                drawWorkerEle.postMessage(workerDrawMessage);
            }

            // Append to the last stroke memento
            // BEST PART IS THAT I DONT HAVE TO DO THIS VIA A WEB-WORKER
            var lastStroke = this.state.lastStrokeMemento
            lastStroke.push([p2.clientX, p2.clientY, -this.state.offsetW, -this.state.offsetH]) // store offsets seperately
            this.setState({
                lastStrokeMemento: lastStroke
            })

        }
    }


    drawTouch = (e) => {
        e.persist();
        // Workerized  drawMouse function
        if (this.state.painting) {
            var touch = this.getTouchPos(e)
            // console.log(touch)
            if (!!!touch) {
                return
            }
            // Get offscreen worker
            var off_screen_context = this.getOffScreenContext()
            var workerDrawMessage = {
                "message_type": "draw",
                "layer_name": this.state.activeLayer.name,
                "x": touch[0] - this.state.offsetW,
                "y": touch[1] - this.state.offsetH,
                "lw": this.state.brushSize,
                "lcap": "round",
                "canvas": off_screen_context
            }

            // load the web-worker for active layer
            var webW = this.state.workerLookup[this.state.activeLayer.name]
            var drawWorkerEle = webW.worker

            try {
                // You must pass context only once. The next time you send, you should just send the message
                drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
            } catch (error) {
                workerDrawMessage['canvas'] = false
                drawWorkerEle.postMessage(workerDrawMessage);
            }

            // Append to the last stroke memento
            // BEST PART IS THAT I DONT HAVE TO DO THIS VIA A WEB-WORKER
            var lastStroke = this.state.lastStrokeMemento
            lastStroke.push([touch[0], touch[1], -this.state.offsetW, -this.state.offsetH]) // store offsets seperately
            this.setState({
                lastStrokeMemento: lastStroke
            })

        }
    }

    // Undo and Redo funcs

    undoAction = () => {
        // Make sure to delete states from your history incase you delete a layer

        // Steps:
        // 1. get the canvas state pointed at by the history pointer -1 (make sure that)
        // 2. Apply that state to the canvas
        // 3. Indicate stroke history to the canvas as well
        var prevHistPointer = this.state.historyPointer - 1 // get previous pointer
        var canvasHistDict = this.state.canvasHistDict

        if (this.state.prevHistPointer < 0) {
            message.error("No more states to undo")
            return
        }

        var previousCanvasData = this.state.canvasHistory[prevHistPointer]
        // console.log(previousCanvasData)

        var off_screen_context = this.getUndoRedoContext(previousCanvasData[0])
        var workerDrawMessage = {
            "message_type": "undo",
            "undo_data": previousCanvasData[1],
            "canvas": off_screen_context
        }

        // load the web-worker for active layer
        var webW = this.state.workerLookup[previousCanvasData[0]]
        var drawWorkerEle = webW.worker

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        // undo stroke history
        var stroke_hist = this.state.strokeHistory
        var last_stroke = stroke_hist.splice(-1, 1)[0]
        var replayBuffer = this.state.strokeUndoReplay
        replayBuffer.push(last_stroke)

        this.setState({
            historyPointer: prevHistPointer,
            canvasHistDict: canvasHistDict,
            strokeUndoReplay: replayBuffer,
            strokeHistory: stroke_hist
        })

    }


    redoAction = () => {
        // TODO
        var nextHistPointer = this.state.historyPointer + 1 // get next pointer
        var canvasHistDict = this.state.canvasHistDict

        if (this.state.prevHistPointer >= this.state.canvasHistory.length) {
            message.error("No more states to redo")
            return
        }

        var nextCanvasData = this.state.canvasHistory[nextHistPointer]

        var off_screen_context = this.getUndoRedoContext(nextCanvasData[0])
        var workerDrawMessage = {
            "message_type": "redo",
            "redo_data": nextCanvasData[1],
            "canvas": off_screen_context
        }

        // load the web-worker for active layer
        var webW = this.state.workerLookup[nextCanvasData[0]]
        var drawWorkerEle = webW.worker

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        // append to stroke history if any message in replay buffer
        var replayBuffer = this.state.strokeUndoReplay
        var strokeHist = this.state.strokeHistory
        if (replayBuffer.length != 0) {
            var lastUndo = replayBuffer.splice(0, 1)[0]
            strokeHist.push(lastUndo)
        }

        this.setState({
            historyPointer: nextHistPointer,
            canvasHistDict: canvasHistDict,
            strokeHistory: strokeHist,
            strokeUndoReplay: replayBuffer
        })

    }

    showLayerDrawer = () => {
        this.setState({
            layerDrawerVisisble: true,
        });
    };

    onLayerDrawerClose = () => {
        this.setState({
            layerDrawerVisisble: false,
        });
    };


    show3DDrawer = () => {
        this.setState({
            Drawer3DVisisble: true,
        });
    };

    on3DClose = () => {
        this.setState({
            Drawer3DVisisble: false,
        });
    };

    addLayerAt = (index) => {
        if (this.state.layerList.length == 10) {
            message.destroy()
            message.error('You can have at most 10 layers!')
            return false
        }
        if (index > this.state.layerList.length) {
            // allowed to add layer at index = 5 is list length is 5
            message.destroy()
            message.error("Index out of bounds")
            return false
        }

        var layerCount = this.state.currentLayerCount + 1
        var layerName = "Layer " + layerCount.toString()

        var canvasHistDict = this.state.canvasHistDict
        canvasHistDict[layerName] = 0

        this.setState({
            canvasHistDict: canvasHistDict
        })

        var newLayer = {
            "index": index,
            "component": <Layer
                name={layerName}
                visibility={this.state.layerVisibilityMap[index]}
                height={this.state.canvHeight}
                width={this.state.canvWidth}
                isBase={false} // only base layer will have a background. Rest will be transparent
            />,
            "name": layerName,
            "visible": true
        }

        // Add worker for new layer
        var WebW = new WebWorker(drawWorker);
        var workerLookup = this.state.workerLookup
        workerLookup[layerName] = WebW

        // console.log(newLayer)
        this.setState({
            currentLayerCount: layerCount,
            workerLookup: workerLookup
        })
        var layerList = this.state.layerList
        layerList.splice(index, 0, newLayer);

        var canvHist = this.state.canvasHistory
        var can = document.getElementById('blank_canvas')
        var ctx = can.getContext('2d')
        canvHist.push([layerName, ctx.getImageData(0, 0, this.state.canvWidth, this.state.canvHeight)])
        this.setState({
            canvasHistory: canvHist,
            historyPointer: this.state.historyPointer + 1
        })

        this.setState({
            layerList: layerList
        })

        this.makeActive(newLayer, layerList.indexOf(newLayer))
        message.destroy()
        message.success('New layer added')

        return true
    }


    toggleLayerVis = (index) => {

        var visibility = this.state.layerVisibilityMap
        visibility[index] = !visibility[index]
        var layerList = this.state.layerList
        layerList[index].visible = !layerList[index].component.props.visibility
        layerList[index].component = React.cloneElement(layerList[index].component,
            {
                visibility: !layerList[index].component.props.visibility
            }
        )
        this.setState({
            layerVisibilityMap: visibility,
            layerList: layerList
        })

    }

    deleteLayer = (layer) => {
        if (layer.name == "Base Layer") {
            message.destroy()
            message.error("Can't delete the base layer. Sorry for leading you on")
            return false
        }

        var l_name = layer.name
        var l_index = this.state.layerList.indexOf(layer)
        var layerList = this.state.layerList

        layerList.splice(l_index, 1)


        var activeLayer = l_index >= layerList.length - 1 ? layerList[l_index - 1] : layerList[l_index + 1]
        // console.log(activeLayer)

        //Delete the worker also
        var workerLookup = this.state.workerLookup
        workerLookup[l_name].terminate(); //termiante the worker before deleting
        delete workerLookup[l_name]

        this.makeActive(activeLayer, layerList.indexOf(activeLayer))
        this.setState({
            layerList: layerList,
            workerLookup: workerLookup
        })
        message.destroy()
        message.info('Deleted: ' + l_name)
        return true


    }

    makeActive = (layer, index) => {
        var active_list = [false, false, false, false, false, false, false, false, false, false]
        active_list[index] = true
        this.setState({
            activeLayer: layer,
            activeList: active_list
        })
    }

    commitListener = (e) => {
        // Call back for the commit data returned by the worker
        //   console.log(e)

        var cdata = e.data.data
        var canvasHist = this.state.canvasHistory
        var historyPointer = this.state.historyPointer + 1
        var canvasHistDict = this.state.canvasHistDict
        // This is an elegant line of code. If after a lot of undos, you make a stroke, this will simply reset histroy

        canvasHistDict[e.data.name] += 1 // Maintain a count of edits made to each layer
        canvasHist.length = historyPointer

        canvasHist.push([e.data.name, cdata])
        // Add a check to see if history exceed 40 states. if it does, then remove the oldest state
        if (canvasHist.length > this.state.maxUndoLimit) {
            canvasHist.shift() // removes the first element
            historyPointer = this.state.maxUndoLimit - 1 // History pointer will always stay at the limit if more states come in

        }
        this.setState({
            canvasHistory: canvasHist,
            historyPointer: historyPointer,
            canvasHistDict: canvasHistDict
        })

    }

    commitCanvasData = async (name) => {
        // This function will commmit the canvas data to canvas history

        // Also make sure that you push the state of the default canvas onto the canvas history
        var canvas = document.getElementById('blank_canvas')
        var ctx = canvas.getContext('2d')

        var off_screen_context = this.getOffScreenContext()
        // load the web-worker for active layer
        var webW = this.state.workerLookup[name]
        var drawWorkerEle = webW.worker

        var workerCommitMessage = {
            "message_type": "commit",
            "layer_name": this.state.activeLayer.name,
            "w": this.state.canvWidth,
            "h": this.state.canvHeight,
            "canvas": off_screen_context
        }

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerCommitMessage, [off_screen_context]);
        } catch (error) {
            workerCommitMessage['canvas'] = false
            drawWorkerEle.postMessage(workerCommitMessage);
        }
        webW.revoke() // cleanup

        var cdata = await drawWorkerEle.addEventListener('message', this.commitListener, false);
        // console.log(this.state.canvasHistory)
        return true
    }

    showFullScreenConfirm = (e) => {
        info({
            title: 'Entering full-screen mode',
            content: 'Consider drawing in full-screen mode for best experence. Press back button in case you wish to exit full-screen',
            onOk() {
                document.body.classList.add("no-sroll")
                document.body.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
            }
        });
    }

    componentDidMount() {
        // React.initializeTouchEvents(true);
        this.setState({
            appLoading: false
        })

        if (window.screen.width > 767) {    // Push the webWorker in state for baseLayer
            var WebW = new WebWorker(drawWorker);
            var workerLookup = this.state.workerLookup
            workerLookup['Base Layer'] = WebW
            // this.drawWorkerEle = this.WebW.worker

            // push base layer when canvas is initialized
            var layerList = this.state.layerList
            var baseL = this.state.baseLayer
            layerList.push(baseL)
            var activeList = this.state.activeList
            activeList[0] = true

            this.setState({
                layerList: layerList,
                currentLayerCount: 0,
                activeList: activeList,
                workerLookup: workerLookup
            })

            var canvHist = this.state.canvasHistory
            var can = document.getElementById('blank_canvas')
            var ctx = can.getContext('2d')
            canvHist.push(['Base Layer', ctx.getImageData(0, 0, this.state.canvWidth, this.state.canvHeight)])

            if (isMobile) {
                // this.showFullScreenConfirm()
                var offsetH = (window.screen.height - this.state.canvHeight) / 2
                var offsetW = (window.screen.width - this.state.canvWidth) / 2
                this.setState({
                    offsetH: offsetH,
                    offsetW: offsetW
                })
            }

            this.setState({
                canvasHistory: canvHist,
                historyPointer: this.state.historyPointer + 1
            })
        }

    }

    // Modal props
    showSaveModal = () => {

        // console.log(this.state.strokeHistory)
        this.setState({
            save_modal_visible: true,
        });
    };

    handleSaveModalOk = async () => {
        this.setState({ save_modal_loading: true });
        message.destroy()
        message.info('Downloading stroke data')
        var device_type = isMobile ? "mobile" : isBrowser ? "pc" : "na"
        var stroke_json = {
            "description": this.state.artTitle,
            "stroke": this.state.strokeHistory,
            "device_type": device_type,
            "canvas_h": this.state.canvHeight,
            "canvas_w": this.state.canvWidth
        }
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(stroke_json));
        var dlAnchorElem = document.getElementById('downloadAnchorElem');
        dlAnchorElem.setAttribute("href", dataStr);
        dlAnchorElem.setAttribute("download", "stroke.json");
        dlAnchorElem.click();
        this.setState({ save_modal_loading: false });
        // var status = await UploadData()
        // if (status) {
        //     this.setState({ save_modal_loading: false, save_modal_visible: false });
        // }
        // else {
        //     message.destroy()
        //     message.error('Could not save the data! Please try again in a minute')
        //     this.setState({ save_modal_loading: false });
        // }
    };

    handleSaveModalCancel = () => {
        this.setState({ save_modal_visible: false });
    };

    captureDrawingTitle = (e) => {
        e.persist()
        if (e.target.value == "") {
            this.setState({
                titlePresent: false
            })
        }
        else {
            this.setState({
                titlePresent: true,
                artTitle: e.target.value
            })
        }
    }


    // Scene stamping 
    cropPlusExport = (img, cropX, cropY, cropWidth, cropHeight) => {
        // create a temporary canvas sized to the cropped size
        var canvas1 = document.createElement('canvas');
        var ctx1 = canvas1.getContext('2d');
        canvas1.width = cropWidth;
        canvas1.height = cropHeight;
        // use the extended from of drawImage to draw the
        // cropped area to the temp canvas
        ctx1.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
        // return the .toDataURL of the temp canvas
        return (canvas1.toDataURL());
    }

    stampScene = async () => {
        var canv3d = document.getElementById('3d_canv').firstElementChild;
        var ctx = canv3d.getContext("experimental-webgl", { preserveDrawingBuffer: true });
        var dt = canv3d.toDataURL();

        const imgBlob = await fetch(dt).then(r => r.blob())
        const img = await createImageBitmap(imgBlob,
            0,
            0,
            this.state.canvWidth,
            this.state.canvHeight)

        // damn I'm big genius for this haha
        var YOffset = this.state.offsetH == 0 ? 0 : -(this.state.offsetH)
        var XOffset = this.state.offsetW

        var off_screen_context = this.getOffScreenContext()
        var workerDrawMessage = {
            "message_type": "stamp",
            "layer_name": this.state.activeLayer.name,
            "stamp": img,
            "y_offset": YOffset,
            "opacity": 0.8,
            "canvas": off_screen_context
        }

        // load the web-worker for active layer
        var webW = this.state.workerLookup[this.state.activeLayer.name]
        var drawWorkerEle = webW.worker

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        this.on3DClose()
    }


    zoom = (scale) => {
        /**
         * Another futile attempt at zooming in lole hahaha
         */

        for (var key in this.state.offScreenContexts) {
            // check if the property/key is defined in the object itself, not in parent
            // if (dictionary.hasOwnProperty(key)) {           
            //     console.log(key, dictionary[key]);
            // }

            var off_screen_context = this.state.offScreenContexts[key]
            var workerDrawMessage = {
                "message_type": "zoom_in",
                "layer_name": key,
                "scale": scale,
                "canvas": off_screen_context
            }

            // load the web-worker for active layer
            var webW = this.state.workerLookup[this.state.activeLayer.name]
            var drawWorkerEle = webW.worker

            try {
                // You must pass context only once. The next time you send, you should just send the message
                drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]);
            } catch (error) {
                workerDrawMessage['canvas'] = false
                drawWorkerEle.postMessage(workerDrawMessage);
            }
        }

    }

    onCropChange = crop => {
        this.setState({ crop })
    }

    onCropComplete = (croppedArea, croppedAreaPixels) => {
        console.log(croppedArea, croppedAreaPixels)
    }

    onZoomChange = zoom => {
        this.setState({ zoom })
    }

    handleDownloadPNG = (layer) => {
        this.setState({
            save_modal_loading: true
        })
        message.info("Beginning download")

        var off_screen_context = this.getOffScreenContext()
        // load the web-worker for active layer
        var webW = this.state.workerLookup[layer.name]
        var drawWorkerEle = webW.worker

        var workerCommitMessage = {
            "message_type": "download",
            "layer_name": this.state.activeLayer.name,
            "w": this.state.canvWidth,
            "h": this.state.canvHeight,
            "canvas": off_screen_context
        }

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerCommitMessage, [off_screen_context]);
        } catch (error) {
            workerCommitMessage['canvas'] = false
            drawWorkerEle.postMessage(workerCommitMessage);
        }
        webW.revoke() // cleanup

        // var cdata = await drawWorkerEle.addEventListener('message', this.commitListener, false);

        drawWorkerEle.onmessage = function (e) {
            try {
                message.info('Downloading as .png')
                console.log(e.data)
                var link = URL.createObjectURL(e.data.blob);
                var dlAnchorElem = document.getElementById('downloadAnchorElem');
                dlAnchorElem.setAttribute("href", link);
                dlAnchorElem.setAttribute("download", e.data.fname + ".png");
                dlAnchorElem.click();
                message.destroy()

            } catch (error) {
                message.destroy()
                message.error("Oops! Something went wrong while downloading layer. Please try again!")
            }

        }


        this.setState({
            save_modal_loading: false
        })
    }


    render() {
        // hotkeys
        const keyMap = {
            TOGGLEHIDE: 'ctrl+shift+h'
        };

        const keyHandlers = {
            TOGGLEHIDE: () => {
                message.destroy()
                if (!this.state.hideHeader) {
                    message.info("Header is hidden! Press ctrl+shift+h to show again", 3)
                }

                this.setState({
                    hideHeader: !this.state.hideHeader
                })
            }
        }
        return (

            <HotKeys keyMap={keyMap} handlers={keyHandlers}>
                <Spin size="large" spinning={this.state.appLoading}>
                    <Desktop>
                        <Layout>

                            <Sider
                                width={this.state.siderWidth}
                                style={{
                                    padding: '20px'
                                }}
                            >
                                <a id="downloadAnchorElem" style={{ display: "none" }}></a>
                                <div >
                                    <Typography.Title level={3}
                                        style={{
                                            color: 'white'
                                        }}

                                    >Superpaper v0.1.0</Typography.Title>

                                    <a href="https://twitter.com/shvbsle" target="_blank"><TwitterOutlined style={{ padding: '5px' }} />Follow Me On Twitter for Updates!</a>

                                    <br></br>
                                    <br></br>
                                    <Typography.Paragraph style={{
                                        color: 'white',
                                        textAlign: 'left'
                                    }}>
                                        Superpaper is a canvas to capture your brush-strokes with three expected outcomes:
                                        <ul>
                                            <li>Harvest a rich dataset of brush-strokes</li>
                                            <li>Bootstrap a model that can decompose any image into a set of brush strokes</li>
                                            <li>Build a transformer to manipulate any image</li>
                                        </ul>
                
                                    </Typography.Paragraph>
                                    <Typography.Title level={4}
                                        style={{
                                            color: 'white'
                                        }}
                                    >
                                        What can you do with this?
                        </Typography.Title>
                                    <Typography.Paragraph style={{
                                        color: 'white',
                                        textAlign: 'left'
                                    }}>
                                        <ul>
                                            <li>Generate pose references by clicking '3D' button</li>
                                            <li>Infer pose from an image in '3D' window [coming soon]</li>
                                            <li>Stamp on multi-layered canvas and create a custom scene</li>
                                            <li>Export all layers as PNG</li>
                                        </ul>
                                    </Typography.Paragraph>

                                    <Typography.Title level={4}
                                        style={{
                                            color: 'white'
                                        }}
                                    >
                                        For Researchers
                        </Typography.Title>
                                    <Typography.Paragraph style={{
                                        color: 'white',
                                        textAlign: 'left'
                                    }}>
                                        <ul>
                                            <li>Export Drawing Strokes</li>
                                            <li>Export Color Stroke data [coming soon]</li>
                                        </ul>
                                    </Typography.Paragraph>

                                    <Typography.Text level={4}
                                        style={{
                                            color: 'white'
                                        }}
                                    >
                                        Reach out to me for feedback, bug reports or feature requests
                        </Typography.Text>
                        <br></br>
                        <a href="mailto:shivbhosale97@gmail.com">Drop a mail!</a>

                                </div>
                            </Sider>
                            <Layout>
                                <canvas
                                    id="blank_canvas"
                                    style={{
                                        height: this.state.canvHeight,
                                        width: this.state.canvWidth,
                                        position: 'fixed',
                                        marginLeft: -this.state.canvWidth / 2,
                                        marginTop: -this.props.canvHeight / 2,
                                        zIndex: -1
                                    }}
                                />
                                <Header style={{
                                    position: 'fixed',
                                    zIndex: 1, width: window.innerWidth - this.state.siderWidth, height: '40px',
                                    backgroundColor: 'transparent',
                                    display: this.state.hideHeader ? 'none' : 'block'
                                }}>
                                    <div className="logo" />

                                    {/* UNDO REDO FUNCTIONS */}

                                    <Tooltip placement="bottom" title="Undo">
                                        <Button
                                            disabled={this.state.historyPointer > 0 ? false : true}
                                            style={{
                                                marginRight: '10px',
                                                backgroundColor: '#ff8c19',
                                                color: 'white',
                                            }}
                                            onClick={this.undoAction}
                                            shape='circle' icon={<UndoOutlined />}></Button></Tooltip>

                                    <Tooltip placement="bottom" title="Redo">
                                        <Button
                                            disabled={this.state.historyPointer < this.state.canvasHistory.length - 1 ? false : true}
                                            style={{
                                                backgroundColor: '#ff8c19',
                                                color: 'white',
                                            }}
                                            onClick={this.redoAction}
                                            shape='circle' icon={<RedoOutlined />}></Button></Tooltip>

                                    <Divider type="vertical" />

                                    {/* LAYERS FUNCTIONS */}
                                    <Tooltip placement="bottom" title="Layers">
                                        <Button
                                            style={{
                                                backgroundColor: '#ff8c19',
                                                color: 'white',
                                            }}
                                            shape='circle' icon={<DiffOutlined />}
                                            onClick={this.showLayerDrawer}></Button></Tooltip>

                                    <Tooltip placement="bottom" title="Save">
                                        <Button
                                            style={{
                                                marginLeft: '10px',
                                                backgroundColor: '#ff8c19',
                                                color: 'white',
                                            }}
                                            onClick={this.showSaveModal}
                                            shape='circle' icon={<SaveOutlined />}></Button></Tooltip>

                                    <Divider type="vertical" />

                                    {/* RIG FUNCTIONS */}

                                    <Tooltip placement="bottom" title="Rigging">
                                        <Button
                                            style={{
                                                backgroundColor: '#ff8c19',
                                                color: 'white',
                                            }}
                                            onClick={this.show3DDrawer}
                                            shape='circle' >3D</Button></Tooltip>
                                </Header>
                                <Content className="site-layout" style={{
                                    position: 'relative',
                                    backgroundColor: '#c1d4fa',
                                    height: '100vh',
                                    display: 'table-cell',
                                    verticalAlign: 'middle'
                                }}>
                                    <center>
                                        {/* {this.state.baseLayer} */}
                                        <div onTouchStart={this.startTouchPosition}
                                            onTouchEnd={this.finishPosition}
                                            onTouchMove={this.drawTouch}

                                            onMouseDown={this.startPosition}
                                            onMouseUp={this.finishPosition}
                                            onMouseMove={this.drawMouse}

                                            style={{
                                                cursor: 'crosshair',
                                                position: "relative"
                                            }}

                                        >

                                            {this.state.layerList.map(layer => <div



                                            >{layer.component}</div>)}

                                        </div>

                                    </center>

                                    <Rig

                                        on3DClose={this.on3DClose}
                                        Drawer3DVisisble={this.state.Drawer3DVisisble}
                                        StampScene={this.stampScene}
                                        siderOffset={this.state.siderWidth}
                                        activeLayerName={this.state.activeLayer.name}

                                    />

                                    <Drawer

                                        placement="right"
                                        closable={false}
                                        onClose={this.onLayerDrawerClose}
                                        visible={this.state.layerDrawerVisisble}
                                    >
                                        <center>
                                            <Badge count={this.state.layerList.length}
                                                style={{
                                                    backgroundColor: '#ff8c19'
                                                }} />

                                            {this.state.layerList.map(layer => <div>
                                                <Card
                                                    hoverable

                                                    style={{
                                                        width: '100%', marginTop: 16,
                                                        backgroundColor: this.state.activeList[this.state.layerList.indexOf(layer)] ? '#429494' : null,

                                                        padding: '5px'
                                                    }}
                                                    actions={[<EditOutlined onClick={() => { this.makeActive(layer, this.state.layerList.indexOf(layer)) }} />,
                                                    (layer.visible) ? (<EyeOutlined onClick={() => this.toggleLayerVis(this.state.layerList.indexOf(layer))} />) :
                                                        (<EyeInvisibleOutlined onClick={() => this.toggleLayerVis(this.state.layerList.indexOf(layer))} />),
                                                    <DeleteOutlined onClick={() => { this.deleteLayer(layer) }} />
                                                    ]}
                                                >
                                                    <Meta

                                                        title={<div style={{
                                                            color: this.state.activeList[this.state.layerList.indexOf(layer)] ? 'white' : 'black',
                                                        }}>{layer.name}</div>}
                                                    />
                                                </Card>
                                                <p></p>
                                                <Button
                                                    size='small'
                                                    style={{
                                                        backgroundColor: '#ff8c19',
                                                        color: 'white'
                                                    }}
                                                    shape='round' icon={<PlusOutlined />}
                                                    onClick={() => { this.addLayerAt(this.state.layerList.indexOf(layer) + 1) }}>Add Layer</Button>
                                            </div>)}
                                        </center>
                                    </Drawer>
                                    <Modal
                                        visible={this.state.save_modal_visible}
                                        title="Download Data"
                                        onCancel={this.handleSaveModalCancel}
                                        footer={null}
                                    >
                                        <Tabs defaultActiveKey="1" >
                                            <TabPane tab="Scene Data" key="1">
                                                <Statistic title="Active Layer" value={this.state.activeLayer['name']} />
                                                Download current layer in PNG format
                                                <br></br>

                                                <br></br>
                                                <Button
                                                    key="submit"
                                                    type="primary"
                                                    loading={this.state.save_modal_loading}
                                                    onClick={() => { this.handleDownloadPNG(this.state.activeLayer) }}>
                                                    Download
                                                    </Button>
                                            </TabPane>
                                            <TabPane tab="Stroke Data" key="2">
                                                {this.state.strokeHistory.length == 0 ?
                                                    <div>
                                                        You haven't drawn anything yet!
                                                        <br></br>
                                                        <br></br>
                                                    </div> :
                                                    <div>
                                                        <p>
                                                            <Input placeholder="Enter a description for the data"
                                                                onChange={this.captureDrawingTitle}
                                                            />
                                                            <br></br>
                                                            <br></br>
                                                            <Statistic title="Total Strokes" value={this.state.strokeHistory.length} />
                                                            <br></br>

                                                            Click to Download the JSON
                                            </p>
                                                    </div>
                                                }
                                                <Button
                                                    disabled={(this.state.strokeHistory.length == 0 || !this.state.titlePresent) ? true : false}
                                                    key="submit"
                                                    type="primary"
                                                    loading={this.state.save_modal_loading}
                                                    onClick={this.handleSaveModalOk}>
                                                    Download
                                                    </Button>
                                                <br></br>
                                                <br></br>

                                                    Your data is stored in the following format:
                                                    <ReactJson collapsed={true} src={this.state.sample_stroke_format} theme="monokai" />

                                            </TabPane>
                                        </Tabs>
                                    </Modal>
                                </Content>
                            </Layout>
                        </Layout>
                    </Desktop>
                    <Mobile>
                        <Layout>
                            <div style={{
                                padding: '10px',
                                paddingTop: '20px',
                                height: '100vh',
                                backgroundColor: '#001529'
                            }}>
                                <Typography.Title level={3}
                                    style={{
                                        color: 'white',
                                    }}

                                >Superpaper v0.1.0</Typography.Title>

                                <a href="https://twitter.com/shvbsle" target="_blank"><TwitterOutlined style={{ padding: '5px' }} />Follow Me On Twitter for Updates!</a>

                                <br></br>
                                <br></br>
                                <Typography.Title level={4}
                                    style={{
                                        color: 'white'
                                    }}
                                >
                                    What Can you do with this?
                        </Typography.Title>
                                <Typography.Paragraph style={{
                                    color: 'white',
                                    textAlign: 'left'
                                }}>
                                    <ul>
                                        <li>Generate pose references by clicking '3D' button</li>
                                        <li>Infer pose from an image in '3D' window [coming soon]</li>
                                        <li>Stamp on multi-layered canvas and create a custom scene</li>
                                        <li>Export all layers as PNG</li>
                                    </ul>
                                </Typography.Paragraph>

                                <Typography.Title level={4}
                                    style={{
                                        color: 'white'
                                    }}
                                >
                                    For Researchers
                        </Typography.Title>
                                <Typography.Paragraph style={{
                                    color: 'white',
                                    textAlign: 'left'
                                }}>
                                    <ul>
                                        <li>Export Drawing Strokes </li>
                                        <li>Export Color Stroke data [coming soon]</li>
                                    </ul>
                                </Typography.Paragraph>

                                <br></br>
                                <br></br>
                                <Typography.Text
                                    style={{
                                        color: 'white'
                                    }}
                                ><DesktopOutlined /> These features are available on desktop/tablet only</Typography.Text>

                            </div>
                        </Layout>
                    </Mobile>

                </Spin>
            </HotKeys>
        );
    }
};